var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrow3LeftDown(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#002A69",
    fillRule: "nonzero",
    d: "M8.086 13.793V9.414a1.5 1.5 0 0 0-3 0v8a1.5 1.5 0 0 0 1.5 1.5h8a1.5 1.5 0 1 0 0-3h-4.379l8.157-8.157a1.5 1.5 0 1 0-2.121-2.12l-8.157 8.156Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrow3LeftDown);
export default __webpack_public_path__ + "static/media/Arrow_3_left_down.9695339a4763872b76ee9dc350b21abb.svg";
export { ForwardRef as ReactComponent };